window.ktDefaultToShow = {}; // Initialize as an object
window.ktDefaultToShow['kt_datatable_statuses'] = 25;
window.ktDefaultToShow['kt_datatable_amortizations'] = 25;

window.enhancePaginationLengthDropdown = function(dtElementId, datatable) {
    // Wait for DOM updates
    setTimeout(() => {
        const dtWrapper = $(datatable.table().container());
        const lengthSelect = dtWrapper.find('select[name$="_length"]');

		lengthSelect.select2({
			minimumResultsForSearch: Infinity, // No search
			width: 'auto'
		}).val(window.ktDefaultToShow[dtElementId] || lengthSelect.find('option:first').val()).trigger('change.select2');


        // Set default selected if exists
        if (window.dtDefaultToShow[dtElementId]) {
            lengthSelect.val(window.dtDefaultToShow[dtElementId]).trigger('change.select2');
        }
		
        // Handle "save as default" checkbox
        dtWrapper.on('change', 'select[name$="_length"]', function () {
            $('.save-dt-length-default').prop('checked', false); // reset
        });

        dtWrapper.on('change', '.save-dt-length-default', function () {
            const isChecked = $(this).is(':checked');
            const selectedValue = lengthSelect.val();
            const dtId = $(this).data('dt-id');

            if (isChecked) {
                $.ajax({
                    url: '/api/set-dt-length-default',
                    method: 'POST',
                    data: {
                        dt_id: dtId,
                        length: selectedValue
                    },
                    success: function () {
                        console.log(`Default length for ${dtId} saved as ${selectedValue}`);
                    },
                    error: function () {
                        alert('Error saving default setting.');
                    }
                });
            }
        });
    }, 10);
}